export default __webpack_public_path__ + "static/media/teknoSpec.a3f4591b.png";